import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { RollMaterialSelector } from "./RollMaterialSelector";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";

interface RollApplicationsToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	rollMaterialId: number | null;
	onRollMaterialChange: (value: number | null) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
}

export const RollApplicationsToolbar = ({
	search,
	onSearchChange,
	rollMaterialId,
	onRollMaterialChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
}: RollApplicationsToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				mb: 1,
			}}
		>
			<TextField
				size="small"
				placeholder="Search..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<RollMaterialSelector
				value={rollMaterialId}
				onChange={onRollMaterialChange}
				includeAll
				size="small"
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
			>
				ADD ROLL APPLICATION
			</Button>
		</Box>
	);
};
